/* tslint:disable:variable-name */
import { Injectable, Inject } from '@angular/core';

import { ISchema, BaseApiClient } from '../common/index';
export { IBaseApiClient } from '../common/interfaces';
import { BaseEntity, Field } from '../common/meta';
import {
    instanceCodeClientT, IInstanceCodeClient, paramsBuilderT,
    IParamsBuilder
} from '../common/interfaces';
import { AuthHttp } from '../authentication/authentication.service';
import { IGoogleDeviceCategory, IGoogleDeviceCategoryClient } from './interfaces';

export class GoogleDeviceCategory extends BaseEntity<IGoogleDeviceCategory> implements IGoogleDeviceCategory {

    public static readonly type: string = 'google_device_category';

    @Field()
    id: string;

    @Field()
    name: string;

    @Field()
    google_id: string;

}

@Injectable()
export class GoogleDeviceCategoryClient extends BaseApiClient<IGoogleDeviceCategory>
    implements IGoogleDeviceCategoryClient {
    protected static classConfig: ISchema = {
        apiResourceName: 'google_device_categories'
    };

    constructor(
        http: AuthHttp,
        @Inject(instanceCodeClientT) instanceCodeClient: IInstanceCodeClient,
        @Inject(paramsBuilderT) paramsBuilder: IParamsBuilder
    ) {
        super(http, instanceCodeClient, paramsBuilder);
    }

    protected implementationClass() {
        return GoogleDeviceCategory;
    }
}
